import axios from 'axios'
import { useUserStore } from '@/stores/user'

const apiBase = 'https://ncht.bz'

function http() {
  const userStore = useUserStore()
  return axios.create({
    baseURL: `${apiBase}/api/theme-images`,
    headers: {
      Authorization: `Bearer ${userStore.token}`,
    },
  })
}

/**
 * Баннер = место (group) + картинка + необязательные название урока и ссылка.
 * Список открытый: баннеры добавляются и удаляются, а не только редактируются.
 */
export const themeImagesApi = {
  load: () => http().get('/admin'),

  addBanner: (group, payload) => {
    const body = new FormData()
    if (payload.image) body.append('image', payload.image)
    if (payload.link) body.append('link', payload.link)
    if (payload.lesson) body.append('lesson', payload.lesson)
    if (payload.file) {
      body.append('file', payload.file)
      return http().post('/banners?file=1', body, { params: { group } })
    }
    return http().post('/banners', { group, ...payload })
  },

  updateBanner: (id, payload) => http().put(`/banners/${id}`, payload),

  uploadBannerFile: (id, file) => {
    const body = new FormData()
    body.append('file', file)
    return http().post(`/banners/${id}/file`, body)
  },

  deleteBanner: (id) => http().delete(`/banners/${id}`),
}
